
export const APP_GROUP_ROUTES = {
    BASE: '/app/*',
    DASHBOARD: `/dashboard/*`,
    BIOMARKERS: `/biomarkers/*`,
    FOOD_INTOLERANCE: `/food-intolerance/*`,
    RECOMMENDATIONS: `/recommendations/*`,
    CUSTOMER_MANAGEMENT: `/customer-management/*`,
    CUSTOMER_RESULTS: `/customer-results/*`,
    CONTENT_PLAYGROUND: '/content-playground/*',
    FOOD_AND_DIET: '/food-and-diet/*',
    PROGRAMS: '/programs/*',
    USER_SEGMENTS: '/user-segments/*',
    FITNESS: '/fitness/*',
    HEALTH_PROGRAM: '/health-program/*',
    MEALPLAN: '/mealplan/*',
    UI_CUSTOMISATION: '/ui-customisation/*',
    ORGANISATIONS: '/organisations',
    CONTENTS: '/contents/*',
    MOBILE_APP_CUSTOMISATION: '/mobile-app-customisation/*',
    NOTIFICATIONS: '/notifications/*',
    ADMINS: '/admins/*',
    PRACTITIONERS: '/practitioners',
    SAMPLES_PAGE: '/samples/*',
};

export const APP_GROUP_LINKS = {
    BASE: '/app',
    DASHBOARD: `/app/dashboard`,
    BIOMARKERS: `/app/biomarkers`,
    RECOMMENDATIONS: `/app/recommendations`,
    CUSTOMER_MANAGEMENT: `/app/customer-management`,
    CUSTOMER_RESULTS: `/app/customer-results`,
    CONTENT_PLAYGROUND: '/app/content-playground',
    PROGRAMS: '/app/programs',
    FITNESS: '/app/fitness',
    MEALPLAN: '/app/mealplan',
    UI_CUSTOMISATION: '/app/ui-customisation',
    HEALTH_PROGRAM: '/app/health-program/',
    ORGANISATIONS: '/app/organisations',
    CONTENTS: '/app/contents',
    PARTNERS: '/app/partners',
    PRACTITIONERS: '/app/practitioners',
    SAMPLES_PAGE: '/app/samples',
};

export const SIDEBAR_SERVICE_MAP = {
    "SIDEBAR.DASHBOARD": "Admin Dashboard",
    "SIDEBAR.BIOMARKERS": ["Blood biomarkers", "DNAm biomarkers", "Skin biomarkers"],
    "SIDEBAR.FOOD_INTOLERANCE": "Food Intolerance",
    "SIDEBAR.RECOMMENDATIONS": "Recommendations",
    "SIDEBAR.CUSTOMER_MANAGEMENT": "Customer Management",
    "SIDEBAR.CUSTOMER_RESULTS": "Customers Result",
    "SIDEBAR.NUTRITION": "Nutrition programs",
    "SIDEBAR.FITNESS": "Fitness programs",
    "SIDEBAR.WELLNESS": "Wellness programs",
    "SIDEBAR.CONTENT": "Content",
    "SIDEBAR.FOOD_AND_RECIPES": "Food & Recipes",
    "SIDEBAR.USER_SEGMENTS": "User Segments",
    "SIDEBAR.UI_CUSTOMISATION": "UI Customisation",
    "SIDEBAR.GENERAL": "UI Customisation",
    "SIDEBAR.UI_SETTINGS": "Dashboard UI Customisation",
    "SIDEBAR.ADMIN_PANEL": "Admin UI Customisation",
    "SIDEBAR.EMAILS": "Emails",
    "SIDEBAR.DYNAMIC_WIDGETS": "Dynamic Widgets",
    "SIDEBAR.APP_CUSTOMIZATION": "App Customisation",
    "SIDEBAR.MEALPLAN": "Nutrition programs",
    "SIDEBAR.PRACTITIONERS": "Practitioners",
    "SIDEBAR.NOTIFICATIONS": "Mobile Notifications",
    "SIDEBAR.SAMPLES_PAGE": "Samples page"
  };
